import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service7Second = () => {
    return (
        <div className="about-events-main-container"> {/* Main outer container */}
            <div className="about-events-container2">
                <div className="about-events-wrapper"> {/* Flexbox container */}
                    <div className="about-events-content2">
                        <h2 className="about-header-service2">BYOC Package Details</h2>
                        <p className="about-events-description2">
                            Celebrate your <strong>Special Events</strong> with us! Whether you're planning a joyful gathering with your family, a fun-filled celebration with colleagues, or a memorable day with friends, Cocoloco Garden is the perfect place to embrace the spirit of your life.
                        </p>

                        <ul className="about-events-list2">
                            <h2 className="about-subheader-service2">Exclusive Package Includes:</h2>
                            <li>- Minimum Pax: <strong>30 persons</strong></li>
                            <li>- <strong>Two Double Room</strong> for your comfort and privacy</li>
                            <li>- Provide 3 Service Staff</li>
                            <li>- This Package for 5 Hours and in extra hours charge Rs.15,000.00</li>

                        </ul>
                    </div>

                    <div className="about-events-grid2">
                        <div className="about-events-images2">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/weddd.webp`}
                                className="service2-images3"
                                
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service7Second;
